// Only use mock users if explicitly enabled via environment variable
// Default to false - always use real API in production and development
export const USE_MOCK_USERS = process.env.REACT_APP_USE_MOCK_USERS === 'true';

// Sales flow: when enabled, adds an intermediate customer step before confirmation
export const SALES_CUSTOMER_STEP_ENABLED =
  process.env.REACT_APP_SALES_CUSTOMER_STEP_ENABLED !== 'false';

// Per-branch receipt numbering (e.g. VEV-3482). On by default; set REACT_APP_BRANCH_RECEIPT_NUMBERING_ENABLED=false to disable.
export const BRANCH_RECEIPT_NUMBERING_ENABLED =
  process.env.REACT_APP_BRANCH_RECEIPT_NUMBERING_ENABLED !== 'false';
